import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";

const CreateRoadMap = () => {
  const [type, setType] = useState("");
  const [programId, setProgramId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [error, setError] = useState({});
  const [programs, setPrograms] = useState([]);
  const [modules, setModules] = useState([]);

  const [response, loading, apiError, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  useEffect(() => {
    callAPI("get", "admin/program-module-list", "");
  }, []);

  useEffect(() => {
    if (response?.data) {
      if (response.data.programs) setPrograms(response.data.programs);
      if (response.data.modules) setModules(response.data.modules);
    }
  }, [response]);

  const filteredModules = modules


  const handleCheckboxChange = (id) => {
    setSelectedModuleIds((prev) =>
      prev.includes(id) ? prev.filter((modId) => modId !== id) : [...prev, id]
    );
  };

  const validateForm = () => {
    const newError = {};
    if (!type || !["kids", "student"].includes(type)) {
      newError.type = "Type is required (kids or training)";
    }
    if (!programId) newError.program_id = "Program is required";
    if (selectedModuleIds.length === 0)
      newError.module_ids = "Please select at least one module";
    setError(newError);
    return Object.keys(newError).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const data = {
      type,
      program_id: programId,
      module_ids: selectedModuleIds,
    };

    callAPI("post", "admin/road-maps", data);
  };

  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Roadmap created successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.roadmap.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Create RoadMap"
            subTitle="Select type, program and modules to create a roadmap."
          />

          <form className="card p-4 shadow mt-3" onSubmit={handleSubmit}>
            <div className="row">
              {/* Type Dropdown */}
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Type</label>
                <select
                  className="form-select"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="">-- Select Type --</option>
                  <option value="kids">Kids</option>
                  <option value="student">student</option>
                </select>
                {error.type && (
                  <small className="text-danger">{error.type}</small>
                )}
              </div>

              {/* Program Dropdown */}
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Program</label>
                <select
                  className="form-select"
                  value={programId}
                  onChange={(e) => {
                    setProgramId(e.target.value);
                    setSelectedModuleIds([]);
                    setSearchTerm("");
                    setError({});
                  }}
                >
                  <option value="">-- Select Program --</option>
                  {programs.map((prog) => (
                    <option key={prog.id} value={prog.id}>
                      {prog.name}
                    </option>
                  ))}
                </select>
                {error.program_id && (
                  <small className="text-danger">{error.program_id}</small>
                )}
              </div>

              {/* Search Input */}
              <div className="col-md-12 mb-3">
                <label className="form-label fw-semibold">Search Modules</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by module name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {/* Module Checkboxes */}
            {programId && (
              <>
                <div className="row">
                  {filteredModules.length === 0 && (
                    <p className="text-muted">No matching modules found.</p>
                  )}
                  {filteredModules.map((mod) => (
                    <div className="col-md-3 col-sm-6 mb-3" key={mod.id}>
                      <div
                        className={`border p-3 rounded shadow-sm h-100 ${
                          selectedModuleIds.includes(mod.id)
                            ? "bg-light border-primary"
                            : "bg-white"
                        }`}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`mod-${mod.id}`}
                            checked={selectedModuleIds.includes(mod.id)}
                            onChange={() => handleCheckboxChange(mod.id)}
                          />
                          <label
                            className="form-check-label fw-semibold ms-2"
                            htmlFor={`mod-${mod.id}`}
                          >
                            {mod.name}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {error.module_ids && (
                  <span className="text-danger small">{error.module_ids}</span>
                )}
              </>
            )}

            {/* Submit Button */}
            <div className="text-end mt-3">
              <button type="submit" className="btn btn-sm btn-primary px-4">
                Submit
              </button>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default CreateRoadMap;



